/**
 * "Copy Bottle Allocation" popup — ALPACA parity
 * (SampleRegistrationBottleAllocationViewController.btnCopybottles_BottleAllocation_Execute,
 * model NPSampleLogIn_Bottle): a From sample (defaults to the selected one) and a checked
 * list of the OTHER samples to copy To, with OK / Cancel. Legacy refuses to open with
 * fewer than two samples ("Add atleast two sampleID's") and, on OK, validates From
 * ("Select the from.") before copying.
 */
import { useState } from 'react';
import { AppDialog } from '../../../components/AppDialog';
import { AppDataGrid, type AppColumn } from '../../../components/AppDataGrid';

interface ToRow { id: string }

export function CopyBottlesDialog({ sampleIds, defaultFrom, onClose, onOk, onWarn }: {
  sampleIds: string[];
  defaultFrom: string;
  onClose: () => void;
  onOk: (fromId: string, toIds: string[]) => void;
  onWarn: (msg: string) => void;
}) {
  const [from, setFrom] = useState(defaultFrom || sampleIds[0] || '');
  const [picked, setPicked] = useState<Set<string | number>>(new Set());

  const rows: ToRow[] = sampleIds.filter(id => id !== from).map(id => ({ id }));
  const cols: AppColumn<ToRow>[] = [{ field: 'id', header: 'SampleID', width: 260 }];

  const submit = () => {
    if (!from) { onWarn('Select the from.'); return; }
    const to = [...picked].map(String).filter(id => id !== from);
    if (to.length === 0) { onWarn('Select the To.'); return; }
    onOk(from, to);
  };

  return (
    <AppDialog
      open onClose={onClose} title="Copy Bottle Allocation" icon="ti-copy" width={460}
      footer={<>
        <button className="ca-btn" onClick={onClose}>Cancel</button>
        <button className="ca-btn ca-btn-solid" onClick={submit}><i className="ti ti-check" /> OK</button>
      </>}
    >
      <div className="sr-fgrid" style={{ gridTemplateColumns: '60px minmax(0, 1fr)' }}>
        <label className="req">From</label>
        <select value={from} aria-label="From sample"
          onChange={e => { setFrom(e.target.value); setPicked(new Set()); }}>
          {sampleIds.map(id => <option key={id} value={id}>{id}</option>)}
        </select>
        <label className="req">To</label>
        <div>
          <AppDataGrid<ToRow>
            rows={rows} columns={cols} getRowId={r => r.id}
            selectable selectedIds={picked} onSelectionChange={setPicked}
            defaultPageSize={10} emptyText="No other samples."
          />
        </div>
      </div>
    </AppDialog>
  );
}
